import { isSupported } from "firebase/messaging";
import { useEffect, useState } from "react";

import {
  defaultContextValue,
  PushNotificationsContext,
  PushNotificationsContextState
} from "./context";
import NotificationsSubscriber from "./NotificationsSubscriber";

type Props = {
  children: React.ReactElement;
};

export default function PushNotificationsProvider({ children }: Props) {
  const [state, setState] =
    useState<PushNotificationsContextState>(defaultContextValue);

  useEffect(() => {
    const checkIsSupported = async () => {
      const supported = await isSupported();
      setState({ ready: true, firebaseMessagingIsSupported: supported });
    };
    checkIsSupported();
  }, []);

  return (
    <PushNotificationsContext.Provider value={state}>
      <NotificationsSubscriber>{children}</NotificationsSubscriber>
    </PushNotificationsContext.Provider>
  );
}
